// import _ from 'underscore';
import { View } from 'backbone.marionette';
import Backbone from 'backbone';
import Radio from 'backbone.radio';
import _ from 'lodash';

import lazyLoadView from '@/util/lazyLoadView';
import OrderCommunicationFileUploadTmpl from '@/fileupload/OrderCommunicationFileUploadTmpl.hbs';
import OrderStatuses from '@/enums/OrderStatuses';
import showModal from '@/util/showModal';
import { getUserDetails } from '@/util/RoleUtils';
import showErrorMessage from '@/util/showErrorMessage';
import showSuccessMessage from '@/util/ShowSuccessMessage';
import SearchUsersModalView from '@/views/SearchUsersModalView/SearchUsersModalView';
import OrderTypes from '@/enums/OrderTypes';

import OrderAccess from '../../utils/OrderAccess';
import SideNavSectionView from '../../../common/views/SideNavSectionView';
import OrderHeaderView from '../../views/OrderHeaderView/OrderHeaderView';
import LoadOrderDevices from '../../loaders/OrderDevicesLoader';
import LoadOrderGeneral from '../../loaders/OrderGeneralLoader';
import LoadOrderDelivery from '../../loaders/OrderDeliveryLoader';
import LoadOrderAttachments from '../../loaders/OrderAttachmentsLoader';
import LoadOrderSummary from '../../loaders/OrderSummaryLoader';
import LoadCommunications from '../../../common/loaders/CommunicationsLoader';
import LoadOrderDecision from '../../loaders/OrderDecisionLoader';
import GetOrderCommunications from '../../services/GetOrderCommunications';
import SubmitOrderCommunication from '../../services/SubmitOrderCommunication';
import ValidateOrderModule from '../../services/ValidateOrderModule';
import ReloadViewModule from '../../services/ReloadViewModule';
import LoadOrderInformation from '../../loaders/OrderInformationLoader';
import ReassignOrder from '../../../order/services/ReassignOrder';
import UnclaimOrder from '../../../order/services/UnclaimOrder';
import DeleteOrder from '../../../order/services/DeleteOrder';
import HideOrder from '../../../order/services/HideOrder';

import tmplOrderPage from './OrderPage.hbs';
import './OrderPage.css';

const OrderPage = View.extend({
  template: tmplOrderPage,

  className: 'order-page container-fluid',

  ui: {
    orderHeader: '.order-header',
    sections: '.sections-container'
  },

  childViewEvents: {
    reload: 'reloadEditable',
    reassign: 'onReassignCRS',
    'delete:draft': 'onDeleteDraft',
    print: 'printOrder',
    unclaim: 'onClickUnclaim',
    hide: 'onClickHide'
  },

  regions: {
    orderHeader: '@ui.orderHeader',
    sections: '@ui.sections'
  },

  onRender() {
    this.isEditing = false;
    this.renderChildViews();
  },

  onBeforeDestroy() {
    ValidateOrderModule.reset();
  },

  renderChildViews() {
    this.showHeaderView();
    this.showReturnMessageView();
    this.showSideNavSectionView();
  },

  showHeaderView() {
    const extOrderDetails = this.model.get('extOrderDetails');
    const userDetails = getUserDetails();
    this.model.set('userDetails', userDetails);
    const orderDetails = this.model.get('orderDetails');
    const isEditButtonVisible = OrderAccess.isEditButtonVisible(
      this.options.statusId,
      this.options.isCRSOwner,
      this.isEditing,
      this.model.get('awPackageStatusID')
        ? this.model.get('awPackageStatusID') == 8 ||
            this.model.get('awPackageStatusID') == 11 ||
            this.model.get('awPackageStatusID') < 4
        : true
    );

    const isReassignable = OrderAccess.isReassignable(
      this.options.statusId,
      this.options.isCRSOwner,
      this.isEditing,
      this.model.get('awPackageStatusID')
        ? this.model.get('awPackageStatusID') == 8 ||
            this.model.get('awPackageStatusID') == 11 ||
            this.model.get('awPackageStatusID') < 4
        : true
    );
    //const isPrintable = OrderAccess.isPrintable(orderDetails.orderFormTypeId);
    const isPrintable = true;
    const isDeleteable = OrderAccess.isDeleteable(
      extOrderDetails.statusId,
      extOrderDetails.externalUserID,
      userDetails
    );
    const showUnClaimButton = OrderAccess.isUnClaimButtonVisible(orderDetails, userDetails);
    const showHideButton = OrderAccess.isHideButtonVisible(orderDetails.statusId);

    this.showChildView(
      'orderHeader',
      new OrderHeaderView({
        statusId: this.options.statusId,
        showDeleteButton: isDeleteable,
        showViewEditBtn: isEditButtonVisible,
        showReassignBtn: isReassignable,
        showPrintBtn: isPrintable,
        showUnClaimButton,
        showHideButton,
        isEditing: false,
        model: new Backbone.Model({
          orderId: this.options.orderId,
          commandName: extOrderDetails.commandName,
          commandId: extOrderDetails.commandId,
          dodaac: extOrderDetails.dodac,
          status: this.options.statusName,
          orderType: extOrderDetails.formName,
          customerDetails: {
            firstName: extOrderDetails.externalUserFirstName,
            lastName: extOrderDetails.externalUserLastName,
            email: extOrderDetails.externalUserEmail,
            telephone: extOrderDetails.externalUserTelephone
          }
        })
      })
    );
  },

  showReturnMessageView() {},

  showSideNavSectionView() {
    const isCRSOwner = this.options.isCRSOwner;
    const isOrderPackageCRSOwner = this.options.orderPackageOwners.isCRSOwner;
    const isOrderPackageEPCOwner = this.options.orderPackageOwners.isEPCOwner;
    const statusId = this.options.statusId;
    const allLineItems = this.model.get('allLineItems');
    const orderDetails = this.model.get('orderDetails');
    const orderId = this.model.get('orderId');
    const commandPOCs = this.model.get('commandPOCs');
    const orderTypeId = orderDetails.orderFormTypeId;

    const isAWPackageEditable = this.model.get('awPackageStatusID')
      ? this.model.get('awPackageStatusID') < 4 ||
        this.model.get('awPackageStatusID') == 8 ||
        this.model.get('awPackageStatusID') == 11
      : true;

    const showInternalSubmittedFields = !EXTERNAL && orderDetails.statusId !== OrderStatuses.INTERNAL_DRAFT;
    const showValidation = false;

    const orderPackageId = this.model.get('orderDetails').orderPackageId;

    const isEditable = OrderAccess.isEditable(statusId, isCRSOwner, this.isEditing, isAWPackageEditable);
    const isInfoCommEditable = OrderAccess.isInfoCommEditable(statusId, this.isEditing);
    const isDecisionEditable = OrderAccess.isDecisionEditable(statusId, isCRSOwner);
    const isAttachmentsEditable = OrderAccess.isAttachmentsEditable(
      statusId,
      this.isEditing,
      isCRSOwner,
      isOrderPackageCRSOwner,
      isOrderPackageEPCOwner
    );
    const orderData = { orderId, orderTypeId, isReadOnly: !isEditable, orderDetails, commandPOCs };
    const isSpecialtyRequirement = orderTypeId === OrderTypes.SPECIALTY_REQ;

    const sidenavSectionView = new SideNavSectionView({
      editable: isEditable,
      useNavigationButtons: true,
      activeSectionId: this.options.activeSectionId,
      model: new Backbone.Model({
        submitButtonText: orderDetails.statusId === OrderStatuses.INTERNAL_DRAFT ? 'Send to Customer for Review and Customer Responsibilities Acknowledgment' : 'Submit',
        returnLabel: 'Return to Dashboard',
        returnLink: !EXTERNAL ? '#dashboard' : '#ext/dashboard',
        packageLabel: orderPackageId && !EXTERNAL ? 'Open Order Package' : null,
        packageLink: `#order-package/${orderPackageId}`,
        orderId,
        orderTypeId,
        allLineItems,
        orderDetails
      }),
      collection: new Backbone.Collection([
        {
          id: 'orderDevices',
          title: 'Devices',
          loader: LoadOrderDevices,
          isSavable: isEditable,
          loaderOptions: { ...orderData, isReadOnly: !isEditable, showValidation },
          renderable: true,
          showSubmitButton: !showInternalSubmittedFields && isEditable,
          view: lazyLoadView(() => LoadOrderDevices({ ...orderData, isReadOnly: !isEditable }))
        },
        {
          id: 'orderGeneral',
          title: 'General',
          loader: LoadOrderGeneral,
          isSavable: isEditable,
          loaderOptions: { ...orderData, editable: isEditable },
          renderable: !isSpecialtyRequirement,
          showSubmitButton: !showInternalSubmittedFields && isEditable,
          view: lazyLoadView(() => LoadOrderGeneral({ ...orderData, editable: isEditable }))
        },
        {
          id: 'orderDelivery',
          title: 'Delivery Schedule',
          loader: LoadOrderDelivery,
          isSavable: isEditable,
          loaderOptions: { ...orderData, isReadOnly: !isEditable },
          renderable: true,
          showSubmitButton: !showInternalSubmittedFields && isEditable,
          view: lazyLoadView(() => LoadOrderDelivery({ ...orderData, isReadOnly: !isEditable }))
        },
        {
          id: 'orderAttachments',
          title: 'Attachments',
          loader: LoadOrderAttachments,
          isSavable: isAttachmentsEditable,
          loaderOptions: { ...orderData, isReadOnly: !isAttachmentsEditable },
          renderable: true,
          showSubmitButton: !showInternalSubmittedFields && isEditable,
          view: lazyLoadView(() => LoadOrderAttachments({ ...orderData, isReadOnly: !isAttachmentsEditable })),
          tooltip: {
            text: 'Templates for the required forms are available by clicking the name of the form on the left if needed.\n\nAccepted attachment types are: .doc, .docx, .xls, .xlsx, .xlsm, .pdf, and .msg.',
            placement: 'right'
          }
        },
        {
          id: 'orderSummary',
          title: 'Order Summary',
          loader: LoadOrderSummary,
          loaderOptions: orderData,
          renderable: true,
          showSubmitButton: !showInternalSubmittedFields && isEditable,
          view: lazyLoadView(() => LoadOrderSummary(orderData))
        },
        {
          id: 'orderCommunication',
          title: 'Communication',
          renderable: showInternalSubmittedFields,
          view: EXTERNAL
            ? null
            : lazyLoadView(() =>
                LoadCommunications({
                  editable: isInfoCommEditable,
                  metadata: {
                    objectId: orderId,
                    orderId
                  },
                  orderData,
                  getCommunicationsService: GetOrderCommunications,
                  submitCommunicationService: SubmitOrderCommunication,
                  submitCommunicationAttachmentService: OrderCommunicationFileUploadTmpl,
                  pathToFileId:
                    'html.head.script.Envelope.Body.UploadOrderCommunicationAttachmentResponse.AttachmentID.__text'
                })
              )
        },
        {
          id: 'orderInformation',
          title: 'Information',
          loader: LoadOrderInformation,
          isSavable: isInfoCommEditable,
          loaderOptions: {
            ...orderData,
            editable: isInfoCommEditable,
            showValidation
          },
          renderable: showInternalSubmittedFields,
          view: lazyLoadView(() =>
            LoadOrderInformation({
              ...orderDetails,
              editable: isInfoCommEditable
            })
          )
        },
        {
          id: 'orderDecision',
          title: 'Decision',
          renderable: showInternalSubmittedFields || orderDetails.statusId === OrderStatuses.RETURNED,
          isSavable: isDecisionEditable,
          showSubmitButton: isDecisionEditable,
          loaderOptions: {
            ...orderData,
            editable: isDecisionEditable
          },
          view: lazyLoadView(() =>
            LoadOrderDecision({
              ...orderData,
              editable: isDecisionEditable
            })
          )
        }
      ])
    });

    this.showChildView('sections', sidenavSectionView);

    // Set views to validate
    const renderedModels = _.filter(sidenavSectionView.collection.models, (model) => model.get('renderable'));
    const validatedViews = _.map(renderedModels, (model) => model.get('view'));
    ValidateOrderModule.views = validatedViews;

    const reloadModel = _.find(sidenavSectionView.collection.models, (model) => model.get('id') === 'orderDelivery');
    ReloadViewModule.deliveryScheduleSideNavModel = reloadModel;
  },

  reloadEditable(isEditing) {
    this.options.activeSectionId = this.getActiveSectionId();
    this.isEditing = isEditing;
    this.showSideNavSectionView();
  },

  getActiveSectionId() {
    let activeSectionID = undefined;
    try {
      const sections = this.getChildView('sections');
      const activeLinkIndex = parseInt(sections.linkCollectionView.getActiveLinkIndex());
      const activeModel = sections.linkCollectionView.collection.at(activeLinkIndex);
      activeSectionID = activeModel.get('id');
    } catch (err) {
      // Ignore
    }
    return activeSectionID;
  },

  async onReassignCRS() {
    const user = await showModal({
      title: 'Reassign CRS',
      view: new SearchUsersModalView(),
      dialogClasses: 'modal-lg'
    });

    try {
      await ReassignOrder({
        orderId: this.model.get('orderId'),
        crsId: user.id
      });
    } catch (err) {
      this.showReassignmentErrorMessage();
    }
  },

  async onDeleteDraft() {
    const userDetails = this.model.get('userDetails');
    try {
      await DeleteOrder(this.model.get('orderId'), userDetails.id);
      this.showDraftDeletedSuccessMessage();
      EXTERNAL
        ? Radio.channel('navigate').request('show:ext:dashboard')
        : Radio.channel('navigate').request('show:int:dashboard');
    } catch (err) {
      this.showDraftDeletedErrorMessage();
    }
  },

  async onClickUnclaim() {
    try {
      await UnclaimOrder(this.model.get('orderId'));
      Radio.channel('navigate').request('show:int:dashboard');
      this.showOrderUnclaimedSuccessMessage();
    } catch (err) {
      this.showOrderUnclaimedErrorMessage();
    }
  },

  async onClickHide() {
    try {
      await HideOrder(this.model.get('orderId'));
      const orderHeaderView = this.getChildView('orderHeader');
      orderHeaderView.model.set('status', 'Hidden');
      orderHeaderView.options.showHideButton = false;
      orderHeaderView.render();
      this.showHideSuccessMessage();
    } catch (err) {
      this.showHideErrorMessage();
    }
  },

  printOrder() {
    Radio.channel('navigate').request('show:order:print', this.options.orderId);
  },

  showHideSuccessMessage() {
    showSuccessMessage({
      code: 'hideSuccess',
      title: 'Hide Success',
      message: 'Order Successfully Hidden.',
      hideAfter: 10
    });
  },

  showHideErrorMessage() {
    showErrorMessage({
      errorCode: 'hideError',
      errorTitle: 'Hide Error',
      hideAfter: 10,
      errorMessage:
        'An error occurred while hiding this order. Try again or contact an administrator if your issue persists.'
    });
  },

  showReassignmentErrorMessage() {
    showErrorMessage({
      errorCode: 'reassignmentError',
      errorTitle: 'Reassignment Error',
      errorMessage:
        'An error occurred while reassigning this order. Try again or contact an administrator if your issue persists.'
    });
  },
  showDraftDeletedErrorMessage() {
    showErrorMessage({
      errorCode: 'draftDeletedError',
      errorTitle: 'Draft Deleted Error',
      errorMessage:
        'An error occurred while deleting this order. Try again or contact an administrator if your issue persists.'
    });
  },

  showDraftDeletedSuccessMessage() {
    showSuccessMessage({
      code: 'deleteSuccess',
      title: 'Delete Success',
      message: 'Order Draft Deleted.',
      hideAfter: 5
    });
  },
  showOrderUnclaimedErrorMessage() {
    showErrorMessage({
      errorCode: 'unclaimError',
      errorTitle: 'Unclaim Order Error',
      errorMessage:
        'An error occurred while unclaiming this order. Try again or contact an administrator if your issue persists.'
    });
  },

  showOrderUnclaimedSuccessMessage() {
    showSuccessMessage({
      code: 'unclaimSuccess',
      title: 'Unclaim Success',
      message: 'Order Unclaimed.',
      hideAfter: 5
    });
  }
});

export default OrderPage;
